import { AutoCompleteSelect, Tooltip } from 'aa_common/front-end/antd'
import { IMPAIRMENT_LOSS_APPLY_METHOD } from 'common/constants'
import { useNextEffect } from 'common/hooks/use-next-effect'
import { getNs } from 'common/i18n-config'
import { LedgerSettingsItem } from 'common/models'
import Form from 'components/molecules/Form'
import { get, isEqual } from 'lodash'
import { useMemo } from 'react'
import { useFormContext } from 'react-hook-form'
import { useSelector } from 'react-redux'
import { selectMasterData } from 'store/masterData/selectors'

import { useIsFullImpairment } from '../hooks/use-is-full-impairment'
import { FIELD_NAMES } from '../validation'

const { FormField } = Form
const { SELECT_ON_IMPAIRMENT, END_OF_CURRENT_MONTH } = IMPAIRMENT_LOSS_APPLY_METHOD

const { t, useNsReady } = getNs(['components/organisms/assets/asset-impairment', 'common'])

type ImpairmentMethodProps = {
  ledgerSetting?: LedgerSettingsItem
}

export const ImpairmentMethod = ({ ledgerSetting }: ImpairmentMethodProps) => {
  useNsReady()
  const { control, errors, setValue } = useFormContext()

  const { impairment_loss_apply_method } = useSelector(selectMasterData, isEqual)
  const impairmentMethods = useMemo(() => {
    return impairment_loss_apply_method.filter(item => item.code !== SELECT_ON_IMPAIRMENT)
  }, [impairment_loss_apply_method])

  const isFullImpairment = useIsFullImpairment()
  const isSelectMethodOnImpair = ledgerSetting?.impairment_loss_apply_method === SELECT_ON_IMPAIRMENT

  useNextEffect(() => {
    const impairLossMethod = ledgerSetting?.impairment_loss_apply_method
    if (!isFullImpairment) {
      setValue(FIELD_NAMES.impairment_method, END_OF_CURRENT_MONTH)
    } else if (impairLossMethod && !isSelectMethodOnImpair) {
      setValue(FIELD_NAMES.impairment_method, impairLossMethod)
    }
  }, [setValue, isSelectMethodOnImpair, ledgerSetting?.impairment_loss_apply_method, isFullImpairment])

  if (isFullImpairment && !isSelectMethodOnImpair) {
    return null
  }

  return (
    <FormField title={t('impairment_depreciation_method')} required={isFullImpairment}>
      <Tooltip
        content={!isFullImpairment ? t('impairment_depreciation_method_tooltip') : undefined}
        overlayStyle={{ width: '290px' }}
      >
        <AutoCompleteSelect
          required
          name={FIELD_NAMES.impairment_method}
          valueField="code"
          textField="name_jp"
          placeholder={t('placeholder.please_select')}
          items={impairmentMethods}
          error={get(errors, 'impairment_method.message')}
          control={control}
          disabled={!isFullImpairment}
        />
      </Tooltip>
    </FormField>
  )
}
